import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PeopleSearchCriteria, criteriaHash } from "@/types/peopleSearch";
import { resolvePeopleSearch } from "@/utils/peopleSearchExecutor";
import { useDebouncedValue } from "./useDebouncedValue";

// Live count for the draft criteria. Shares the resolve query key with
// usePeopleSearchResults so applying a previewed draft hits the cache.
export function usePeopleSearchCount(draft: PeopleSearchCriteria) {
	const debounced = useDebouncedValue(draft, 500);

	const query = useQuery({
		queryKey: ['people-search-resolve', criteriaHash(debounced)],
		queryFn: () => resolvePeopleSearch(debounced),
		staleTime: 60 * 1000,
		placeholderData: keepPreviousData,
	});

	return {
		count: query.data?.count ?? null,
		isCounting: query.isFetching || criteriaHash(draft) !== criteriaHash(debounced),
		countError: query.error,
		refetchCount: query.refetch,
	};
}
